import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from 'src/app/core/layout/loader/loading.service';
import { LocationService } from './location.service';
import { UserService } from './user.service';

const isWhitelisted = (url: string) => {
  const whitelisted = ['requests/estimatesv2'];
  return whitelisted.some((item) => url.includes(item));
};

/**
 * It intercepts the HTTP request and rewrites some parts of the address (such as @@location).
 * Show a loader during HTTP request if not find 'hideLoader' header.
 */
@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  private userService = inject(UserService);
  private locationService = inject(LocationService);
  private loadingService = inject(LoadingService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let resultRequest = request;

    const token = this.userService.getToken();
    const companyId = this.userService.userCompany && this.userService.userCompany._id;
    let url = request.url;
    if (token) {
      const authHeader = `Bearer ${token}`;

      // manage location in url with the current location
      const loc = this.locationService.currentLocation;

      if (loc) {
        url = url.replace('@@location', loc._id);
      }
      if (companyId) {
        url = url.replace('@@company', companyId);
      }

      // let wetaxiChannel = {}
      // wetaxiChannel['Wetaxi-Channel'] = 'DASHBOARD';
      resultRequest = request.clone({
        url: url,
        setHeaders: {
          Authorization: authHeader,
        },
      });
    }

    if (resultRequest.headers.get('hideLoader')) {
      resultRequest = resultRequest.clone({
        url: url,
        headers: resultRequest.headers.delete('hideLoader'),
      });
    } else if (resultRequest.method !== 'GET' && !isWhitelisted(url)) {
      this.loadingService.showLoader('fromInterceptor');
    }

    return next.handle(resultRequest).pipe(
      finalize(() => {
        this.loadingService.hideLoader('fromInterceptor');
      })
    );
  }
}
